/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const BankAccount: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M12.2242 2.69512L12.4468 2.73321L12.5836 2.77129C12.8979 2.87256 13.1721 3.05764 13.3883 3.19415L22.0338 8.65411C22.4102 8.89186 22.5843 9.35046 22.4605 9.77813C22.3367 10.2057 21.9447 10.4998 21.4996 10.4998H19.9996V18.9998H21.9996V20.9998H1.99958V18.9998H3.99958V10.4998H2.49958C2.0546 10.4996 1.66244 10.2056 1.53865 9.77813C1.41505 9.35061 1.58921 8.89186 1.9654 8.65411L10.6109 3.19415L10.8101 3.06817C11.0222 2.93674 11.2733 2.79731 11.5523 2.73321L11.775 2.69512C11.9241 2.67827 12.0751 2.6783 12.2242 2.69512ZM5.99958 10.4998V18.9998H10.9996V10.4998H5.99958ZM12.9996 10.4998V18.9998H17.9996V10.4998H12.9996ZM11.9937 4.69219L11.6793 4.88458L5.95564 8.49981H18.0435L12.3199 4.88458C12.1552 4.78055 12.0694 4.72717 12.0054 4.69219C12.0035 4.69106 12.0014 4.68924 11.9996 4.68829C11.9978 4.68932 11.9957 4.69111 11.9937 4.69219Z'
      fill='currentColor'
    />
  </React.Fragment>
)
